import React from 'react';

import PropTypes from 'prop-types';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const SubscriptionUpdateRestrictionPopup = (props) => {
    return (
        <SimplePopup withoutBorder popupRef={props.popupRef} text={props.text}>
            <PopupButton
                iconName="check"
                text={props.buttonText}
                onClick={() => {
                    props.popupRef?.current?.close();
                }}
            />
        </SimplePopup>
    );
};
SubscriptionUpdateRestrictionPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    text: PropTypes.string,
    buttonText: PropTypes.string,
};

export default SubscriptionUpdateRestrictionPopup;
